import { render, staticRenderFns } from "./GeminiSetting.vue?vue&type=template&id=77be7524&"
import script from "./GeminiSetting.vue?vue&type=script&lang=ts&"
export * from "./GeminiSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports